import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfoAlert = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_17364_3301)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M24.9839 49.5116C23.6373 49.5116 22.3899 48.9039 21.5599 47.8427L16.5657 41.5092L7.81134 41.5038C3.50456 41.5038 0 37.9993 0 33.6913V8.20311C0 3.89518 3.50456 0.390625 7.81248 0.390625H42.1874C46.4953 0.390625 49.9999 3.89518 49.9999 8.20311V23.9257C49.9999 25.0045 49.1256 25.8789 48.0468 25.8789C46.968 25.8789 46.0937 25.0045 46.0937 23.9257V8.20311C46.0937 6.04934 44.3412 4.29687 42.1874 4.29687H7.81248C5.65871 4.29687 3.90624 6.04934 3.90624 8.20311V33.6913C3.90624 35.8451 5.65871 37.5976 7.81248 37.5976L17.5148 37.6033C18.1125 37.6037 18.6771 37.878 19.0471 38.3472L24.6322 45.4299C24.7463 45.576 24.8855 45.6054 24.9843 45.6054H24.9862C25.0846 45.605 25.225 45.5749 25.3341 45.4333C25.3376 45.4288 25.341 45.4242 25.3444 45.42L30.8841 38.3464C31.2545 37.8738 31.8214 37.5976 32.4218 37.5976H42.1874C44.3416 37.5976 46.0937 35.8451 46.0937 33.6913C46.0937 32.6125 46.968 31.7382 48.0468 31.7382C49.1256 31.7382 49.9999 32.6125 49.9999 33.6913C49.9999 37.9993 46.4953 41.5038 42.1874 41.5038H33.3732L28.424 47.8229C27.5985 48.891 26.3519 49.5063 25.0015 49.5116C24.9958 49.5116 24.9897 49.5116 24.9839 49.5116ZM26.9531 30.1757V19.6289C26.9531 18.5501 26.0787 17.6757 25 17.6757C23.9212 17.6757 23.0468 18.5501 23.0468 19.6289V30.1757C23.0468 31.2545 23.9212 32.1288 25 32.1288C26.0787 32.1288 26.9531 31.2545 26.9531 30.1757ZM25 10.9375C23.9212 10.9375 23.0468 11.8118 23.0468 12.8906C23.0468 13.9694 23.9212 14.8437 25 14.8437C26.0787 14.8437 26.9531 13.9694 26.9531 12.8906C26.9531 11.8118 26.0787 10.9375 25 10.9375Z",
				fill: "#ADB5BD"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_17364_3301",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgInfoAlert);
export default ForwardRef;
